import { Organization } from "chq";
import tagsTypes from "../../constants/tagsTypes";

const getCompanyFieldCategory = (organization?: Organization) => {
  const labelField = organization?.organizationFields?.find(f => f.table === "companies")?.pluralLabel;
  if (labelField) return labelField?.toLowerCase();

  return tagsTypes.COMPANIES;
};

export default getCompanyFieldCategory;
